module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_hyogo-84a4ccac4e524a2da58cb6fe17e2f972.png";